webpackJsonp([149428911916780],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.f9fed578.png";

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jeff.f5286e86.png";

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sarah.88f251bd.png";

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shaun.4b2caf45.png";

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/steve.58c8b6af.png";

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MasterClassPage;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _TitleSection = __webpack_require__(19);
	
	var _TitleSection2 = _interopRequireDefault(_TitleSection);
	
	var _MaxWidthContainer = __webpack_require__(10);
	
	var _Sessions = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var coverImage = __webpack_require__(151);
	var sarahImage = __webpack_require__(572);
	var shaunImage = __webpack_require__(573);
	var jeffImage = __webpack_require__(571);
	var steveImage = __webpack_require__(574);
	
	function MasterClassPage() {
	  return React.createElement(
	    'main',
	    null,
	    React.createElement(
	      _TitleSection2.default,
	      null,
	      React.createElement(
	        _MaxWidthContainer.RunningTextContainer,
	        null,
	        React.createElement(
	          _Sessions.Title,
	          null,
	          React.createElement(
	            _Sessions.Kicker,
	            null,
	            'Master Class'
	          ),
	          'Cross-Sector Collaboration for Intervention in Complex Urban Systems'
	        ),
	        React.createElement(
	          _Sessions.Row,
	          null,
	          React.createElement(
	            'p',
	            null,
	            'The team behind the case',
	            ' ',
	            React.createElement(
	              'a',
	              { href: 'https://www.learngala.com/cases/urbanwood' },
	              'Rebuilding Communities through an Urban Wood and Land Restoration Economy'
	            ),
	            ' ',
	            'will present their experience designing & implementing a system that employs formerly incarcerated citizens to deconstruct blighted homes and supply this urban wood as lumber for the high-end furniture market. This Master Classes will teach participants to map sustainability systems and identify intervention and leverage points.'
	          ),
	          React.createElement(_Sessions.Image, { src: coverImage })
	        ),
	        React.createElement(
	          'em',
	          null,
	          'Preliminary program details listed below.'
	        )
	      )
	    ),
	    React.createElement(
	      _MaxWidthContainer.RunningTextContainer,
	      null,
	      React.createElement(
	        'h2',
	        null,
	        'Featuring'
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Sarah Hines, US Forest Service'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'p',
	          null,
	          'Sarah has spent her career in the Forest Service linking scientists and scientific information with communities and decision makers at local and regional scales to inform stewardship of everything from our National Forests to the local parks and forests in our communities. She has worked for the Research & Development branch of the Forest Service in Philadelphia, Colorado, and Baltimore. She received a A.B. in biological anthropology from Harvard, and M.S. and M.B.A. degrees from the University of Michigan.'
	        ),
	        React.createElement(_Sessions.Image, { src: sarahImage })
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Shaun Preston, City of Baltimore'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'p',
	          null,
	          'As the Camp Small Yardmaster for the Forestry Division, Shaun manages the wood sorting facility and its urban wood utilization program. He enjoys teaching folks about wood utilization, helping them achieve their creative goals, and he loves seeing when a special old tree is memorialized through repurposing its wood. When he\u2019s not hustling logs you can find Shaun with his family, going on hikes, working in the garden, fishing for trout, building things, making art, playing music, and sometimes watching tv on the couch.'
	        ),
	        React.createElement(_Sessions.Image, { src: shaunImage })
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Jeff Carroll, Humanim'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'p',
	          null,
	          'As a Vice President at Humanim, a workforce development nonprofit serving Maryland for nearly 50 years, Jeff oversees Details Deconstruction and its sister enterprise Brick and Board. He has worked with the Humanim team and its many partners (Baltimore City Housing, Maryland Housing, the U.S. Forest Service, and several for-profit partners) to grow these enterprises from start-up to a collective $4,000,000 operation employing 185 people from Baltimore\u2019s toughest neighborhoods since inception. Jeff lives in Baltimore with his wife Heather, holds an MBA from Johns Hopkins Carey Business School and is a Legacy LEED AP.'
	        ),
	        React.createElement(_Sessions.Image, { src: jeffImage })
	      ),
	      React.createElement(
	        'h3',
	        null,
	        'Steve Freeman, Room & Board'
	      ),
	      React.createElement(
	        _Sessions.Row,
	        null,
	        React.createElement(
	          'p',
	          null,
	          'As Vendor Resource Manager at Room & Board Steve has contributed to the environmentally-focused philosophies and practices of the company and its Vendor Partners over his 39-year career with the furniture retailer. A lifelong Minnesotan, he is inspired by wilderness canoeing in the Boundary Waters Canoe Area Wilderness (BWCAW) of Northern Minnesota as well as the far more remote wilderness areas of northern Canada. Steve and his wife Betsy split time between a home situated on 5 acres of woodland outside of Minneapolis and a small cottage in Ely, Minnesota right next to the BWCAW.'
	        ),
	        React.createElement(_Sessions.Image, { src: steveImage })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sessions-master-class-js-f4ba21f66917a85fbe5e.js